export default [
    {
        name: "01-access",
        title: "Acceso",
        content: require("./content/01-access.txt")
    },
    {
        name: "02-sales",
        title: "Venta",
        content: require("./content/02-sales.txt")
    },
    {
        name: "03-sales-history",
        title: "Historial de Ventas",
        content: require("./content/03-sales-history.txt")
    },
    {
        name: "04-refund",
        title: "Cancelaciones o Devoluciones",
        content: require("./content/04-refund.txt")
    },
    {
        name: "05-catalog",
        title: "Catálogo",
        content: require("./content/05-catalog.txt")
    },
    {
        name: "06-customers",
        title: "Clientes",
        content: require("./content/06-customers.txt")
    },
    {
        name: "07-comments",
        title: "Comentarios",
        content: require("./content/07-comments.txt")
    },
    {
        name: "08-staff",
        title: "Staff",
        content: require("./content/08-staff.txt")
    },
    {
        name: "09-cash-count",
        title: "Cierre de Caja",
        content: require("./content/09-cash-count.txt")
    },
    {
        name: "10-logout",
        title: "Cierre de Sesion",
        content: require("./content/10-logout.txt")
    },
    {
        name: "11-contact-us",
        title: "Contacto",
        content: require("./content/11-contact-us.txt")
    },
    {
        name: "12-terms",
        title: "Terminos y Condiciones",
        content: require("./content/12-terms.txt")
    }
]